import graphql from 'babel-plugin-relay/macro';
import { useLazyLoadQuery } from 'react-relay';

import { GetJobsQuery } from './__generated__/GetJobsQuery.graphql';

const getJobsQuery = graphql`
  query GetJobsQuery {
    getJobs {
      id
      key
      description
      customerId
      customer {
        id
        key
        name
        categoryId
      }
      jobCategoryId
      jobCategory {
        id
        name
      }
      status
      regions {
        id
        name
        enabled
      }
    }
  }
`;

const useGetJobsQuery = ({
  fetchKey
}: {
  fetchKey?: string | number | undefined;
}) => {
  return useLazyLoadQuery<GetJobsQuery>(
    getJobsQuery,
    {},
    { fetchKey, fetchPolicy: 'store-and-network' }
  ).getJobs;
};

export { useGetJobsQuery };
